'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = pauseListener;

var _actions = require('../../store/actions');

var _store = require('../../store');

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Copyright 2016 hudl
 * All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @providesModule defaultPauseListener
 * 
 */

/*
 * The pause listener is called when the video pauses. Pausing is different
 * than a `stalled` or `waiting` event.
 */
function pauseListener(state, next, playerId) {
  var reduxState = _store2.default.storeInstance().getState();
  // only dispatch if the state thinks we are playing
  if (reduxState.players[playerId].paused === false) {
    _store2.default.storeInstance().dispatch((0, _actions.pauseInternal)(playerId));
  }
}
module.exports = exports['default'];